// 导入axios
import Vue from 'vue'
import axios from 'axios';
import { Toast } from 'vant';
Vue.use(Toast);

// 进行一些全局配置
// 公共路由(网络请求地址)
//axios.defaults.baseURL = /api  //'';
// 请求响应超时时间
axios.defaults.timeout = 5000;

axios.interceptors.request.use(
    config => {
        return config;
    },
    error => {
        //console.log(error);
        return Promise.reject();
    }
);
axios.interceptors.response.use(
    response => {
		if(response.status == 200) {
			if(response.data.status == 200 && response.data.code == 200) {
				return Promise.resolve(response);
			}else{
				Toast(response.data.msg);
				return Promise.reject(response);
			}
		}else {
			return Promise.reject(response);
		}
    },
    error => {
        if(error.response.status) {
			Toast(error.response.data.msg);
			return Promise.reject(error.response);
		}
    }
);

// 封装自己的get/post方法
export default {
  get: function(path = '', data = {}) {
    return new Promise(function(resolve, reject) {
      axios.get(path, {
        params: data
      })
        .then(function(response) {
          // 按需求来，这里我需要的是response.data，所以返回response.data，一般直接返回response
          resolve(response.data);
        })
        .catch(function(error) {
          reject(error);
        });
    });
  },
  post: function(path = '', data = {}) {
    return new Promise(function(resolve, reject) {
      axios.post(path, data)
        .then(function(response) {
          resolve(response.data);
        })
        .catch(function(error) {
          reject(error);
        });
    });
  }
};